export const tooltipText =
  'At least one Verifier Admin needs to finish the sign-up process and get Active User status, so you could start invite Verifier Manager to the app';
